var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('HeaderImage'),_c('Navbar'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9 col-sm-12"},[_c('router-view')],1),_c('Contacts')],1),_c('PageFooter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }